import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  logoutRequest: [],
  logoutSuccess: ["status"],
  logoutFailure: null,
});

export const LogoutTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  status: null,
  success: null,
  error: null,
});

export const LogoutSelectors = {
  getData: (state: any) => state.logout.data,
  isFetching: (state: any) => state.logout.fetching,
  isSuccess: (state: any) => state.logout.success,
  hasError: (state: any) => state.logout.error,
  getStatus: (state: any) => state.logout.status,
};

export const request = (state: any, action: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOGOUT_REQUEST]: request,
  [Types.LOGOUT_SUCCESS]: success,
  [Types.LOGOUT_FAILURE]: failure,
});
